import { Employee, SUBCATEGORIES, TABS } from '../types/employee.types'

import compareSubCategories from './compareSubCategories'
import getMinPrioritySubCategory from './getMinPrioritySubCategory'
import getPriorityWithinSubCategory from './getPriorityWithinSubCategory'

export function employeeSort(employees: Employee[], selectedTab: string): Employee[] {
  // eslint-disable-next-line fp/no-mutating-methods
  return employees.sort((a: Employee, b: Employee) => {
    if (a.employeeOrder && !b.employeeOrder) {
      return -1
    }
    if (!a.employeeOrder && b.employeeOrder) {
      return 1
    }
    if (!a.employeeOrder && !b.employeeOrder) {
      return a.name < b.name ? -1 : 1
    }

    if (selectedTab === TABS.all || selectedTab === TABS.crew) {
      const { priorityOfSubcategory: aPriorityOfSubcategory, priorityWithinSubCategory: aPriorityWithinSubCategory } =
        getMinPrioritySubCategory(a.employeeOrder)

      const { priorityOfSubcategory: bPriorityOfSubcategory, priorityWithinSubCategory: bPriorityWithinSubCategory } =
        getMinPrioritySubCategory(b.employeeOrder)

      if (
        aPriorityOfSubcategory < bPriorityOfSubcategory ||
        (aPriorityOfSubcategory === bPriorityOfSubcategory && aPriorityWithinSubCategory < bPriorityWithinSubCategory)
      ) {
        return -1
      } else if (
        aPriorityOfSubcategory > bPriorityOfSubcategory ||
        (aPriorityOfSubcategory === bPriorityOfSubcategory && aPriorityWithinSubCategory > bPriorityWithinSubCategory)
      ) {
        return 1
      }
      return a.name < b.name ? -1 : 1
    } else if (selectedTab === TABS.board) {
      const aPriorityWithinSubCategory = getPriorityWithinSubCategory(SUBCATEGORIES.board, a.employeeOrder)
      const bPriorityWithinSubCategory = getPriorityWithinSubCategory(SUBCATEGORIES.board, b.employeeOrder)

      return compareSubCategories(aPriorityWithinSubCategory, bPriorityWithinSubCategory, a.name, b.name)
    } else if (selectedTab === TABS.management) {
      const aPriorityWithinSubCategory = getPriorityWithinSubCategory(SUBCATEGORIES.management, a.employeeOrder)
      const bPriorityWithinSubCategory = getPriorityWithinSubCategory(SUBCATEGORIES.management, b.employeeOrder)

      return compareSubCategories(aPriorityWithinSubCategory, bPriorityWithinSubCategory, a.name, b.name)
    } else {
      const aPriorityWithinSubCategory = getPriorityWithinSubCategory(SUBCATEGORIES.tutor, a.employeeOrder)
      const bPriorityWithinSubCategory = getPriorityWithinSubCategory(SUBCATEGORIES.tutor, b.employeeOrder)

      return compareSubCategories(aPriorityWithinSubCategory, bPriorityWithinSubCategory, a.name, b.name)
    }
  })
}
